import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout for all /auth/* routes (login, signup, password-reset, etc.).
// Local dev and dev.connect render the same LoginForm — the dev persona
// switcher is inlined into the form via DevPersonaSwitcher.
export const Route = createFileRoute('/auth')({
  component: () => <Outlet />,
});
